// Fetch-based SSE reader. EventSource can't send an Authorization header,
// so <PlunkChat> streams via fetch + ReadableStream and parses the frames
// itself. Contract (ChatService README): event lines `event: <name>` +
// `data: <json>` separated by blank lines.
export async function streamSse(url, {
  method = 'POST',
  headers,
  body,
  signal,
  onEvent
}) {
  const res = await fetch(url, {
    method,
    headers,
    body,
    signal
  });
  if (!res.ok || !res.body) {
    const err = new Error(res.status === 401 || res.status === 403 ? 'auth' : `The assistant is unavailable right now (HTTP ${res.status}).`);
    err.kind = res.status === 401 || res.status === 403 ? 'auth' : 'transient';
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const {
      done,
      value
    } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, {
      stream: true
    });
    let idx;
    while ((idx = buffer.indexOf('\n\n')) !== -1) {
      const frame = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      let event = 'message';
      const dataLines = [];
      for (const line of frame.split('\n')) {
        if (line.startsWith('event:')) event = line.slice(6).trim();else if (line.startsWith('data:')) dataLines.push(line.slice(5).trimStart());
      }
      if (dataLines.length === 0) continue;
      let data;
      try {
        data = JSON.parse(dataLines.join('\n'));
      } catch {
        continue;
      }
      onEvent(event, data);
    }
  }
}